<style lang="less" scoped>
  .content{
      position: relative;
      min-height: 750px;
  }
</style>

<template>
    <Content class="content">
        <slot/>
    </Content>
</template>

<script>
export default {
  name: 'cisContent'
}
</script>
